import { render, staticRenderFns } from "./RecentLessonStateSection.vue?vue&type=template&id=4b012c0a&"
import script from "./RecentLessonStateSection.vue?vue&type=script&lang=ts&"
export * from "./RecentLessonStateSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports